module.exports = __webpack_public_path__ + "img/dmx.e1538fac.webp";